import React from 'react';

import './HeaderMenus.css';

interface HeaderMenusProps {
    // onSelect: (key: string) => void;
}

const FilterSection: React.FC<HeaderMenusProps> = () => {

    return (
        <div className={"HeaderMenus"}>
        </div>
    );
}

export default FilterSection;
